module.exports = __webpack_public_path__ + "static/media/document.669441f7.svg";